<template>
    <div class="firstStep">
      <div class="upliad_box">
        <label>上传文件：</label>
        <span v-show="obj.origName.length">
          <img src="@/assets/excel.svg" alt="">
          {{obj.origName}}
        </span>
        <a href="javascript:;" class="border-btn "  @click="importBtn">上传数据</a>
        <el-upload id="uploading_btn" class="upload-demo" :show-file-list="false"  ref="upload" action="/file/upload.ajax" :before-upload="beforeUpload" :on-success="handleSuccess">
        </el-upload>
      </div>
      <a href="javascript:;" class="change-btn" @click="setActive(2)">下一步</a>
      <p>可参照以下样式制作表格 注意：请上传excel格式的文件，其他格式不支持</p>
      <img src="@/assets/upload_case.png">
    </div>
</template>
<script>
export default {
  data(){
    return{
    }
  },
  props:{
    obj:{
      type:Object
    }
  },
  created(){

  },
  methods:{
    setActive(val){
      if(this.obj.files.length){
        this.$parent.setActive(val)
      }else{
        this.$message.error('请先上传文件')
      }
      
    },
    // 点击上传按钮
    importBtn () {
      document.querySelector('#uploading_btn input').click()
    },
    // 上传文件
    handleSuccess (response, file) {
      if (response.s == 1) {
        this.obj.type = response.d.suffix
        this.$parent.obj.files = response.d.savePath
        this.$parent.obj.type = response.d.suffix
        this.$parent.obj.origName = response.d.originalFilename.substring(0,response.d.originalFilename.indexOf('.'))
        this.$parent.list=[]
        this.$parent.list2=[]
        
      } else {
        this.$message.error(response.d)
      }
    },
  }
}
</script>
<style lang="less" scoped>
.firstStep{
  text-align: center;
  font-size: 14Px;
  margin-top: 60Px;
  .upliad_box{
    label{
      font-size: 16Px;
    }
    .icon{
      width: 24Px;
      height: 24Px;
      vertical-align: middle;
    }
    .border-btn{
      background: #E6F1FC;
      margin-left: 14Px;
    }
    img{width: 24Px;vertical-align: middle;}
  }
  .change-btn{
    margin: 60Px 0;
  }
  &>p{
    color: #666;
  }
  &>img{
    margin: 10Px 0 50Px;
  }
}
</style>